export const ERROR_MSG = "Something went wrong. Please try again.";

export const COUNTRY_OPTIONS = [
  {
    name: "Canada",
    value: "+1",
    code: "CA"
  },
  {
    name: "United States",
    value: "+1",
    code: "US"
  },
  {
    name: "United Kingdom",
    value: "+44",
    code: "GB"
  },
  {
    name: "Australia",
    value: "+61",
    code: "AU"
  }
];

export const NOTIFICATION_DATA = [
  {
    title: "Product launches",
    tag: "launches",
    sms: "preferences_launches_sms",
    email: "preferences_launches_email"
  },
  {
    title: "Sustainability stories",
    tag: "sustainability",
    sms: "preferences_sustainability_sms",
    email: "preferences_sustainability_email"
  },
  {
    title: "Sales and promotions",
    tag: "sales",
    sms: "preferences_sales_sms",
    email: "preferences_sales_email"
  },
  {
    title: "Community features",
    tag: "community",
    sms: "preferences_community_sms",
    email: "preferences_community_email"
  },
  {
    title: "Lifestyle and DIY tips",
    tag: "lifestyle_tips",
    sms: "preferences_lifestyle_tips_sms",
    email: "preferences_lifestyle_tips_email"
  },
  {
    title: "Behind the design",
    tag: "btd",
    sms: "preferences_btd_sms",
    email: "preferences_btd_email"
  },
  {
    title: "Styling advice",
    tag: "styling",
    sms: "preferences_styling_sms",
    email: "preferences_styling_email"
  }
];

export const SHOPPING_PREFS_DATA = [
  {
    label: "Womenswear",
    value: "Female"
  },
  {
    label: "Menswear",
    value: "Male"
  },
  {
    label: "Home",
    value: "Home"
  }
];
